import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ec92a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.segment.alias ? 'headline_' + _ctx.segment.alias : '',
    class: _normalizeClass([[_ctx.segment.headlineType, 'text-'+_ctx.segment.alignment], "headline"]),
    innerHTML: _ctx.decodeHtmlString(_ctx.segment.content)
  }, null, 10, _hoisted_1))
}